"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AbstractStringLogger = void 0;
const logLevel_1 = require("./logLevel");
/**
 * Base class for all string loggers.
 */
class AbstractStringLogger {
    /**
     * Initializes a new instance of the @see AbstractLogger class.
     * @param minimumLevel The minimum log level this logger accepts for log messages.
     */
    constructor(minimumLevel) {
        this.minimumLevel = minimumLevel;
    }
    /**
     * Writes a log entry.
     * @param logLevel Entry will be written on this level.
     * @param requestId Guid of the request.
     * @param state The entry to be written. Can be also an object.
     * @param error The error related to this entry.
     * @param formatter Function to create a string message of the state and error.
     */
    log(logLevel, requestId, state, error, formatter) {
        if (this.isInLogLevel(logLevel)) {
            this.logHandler(logLevel, requestId, state, error, formatter);
        }
    }
    /**
     * Writes a trace log entry.
     * @param requestId Guid of the request.
     * @param state The entry to be written. Can be also an object.
     * @param error The error related to this entry.
     * @param formatter Function to create a string message of the state and error.
     */
    trace(requestId, state, error, formatter) {
        this.log(logLevel_1.LogLevel.Trace, requestId, state, error, formatter);
    }
    /**
     * Writes a debug log entry.
     * @param requestId Guid of the request.
     * @param state The entry to be written. Can be also an object.
     * @param error The error related to this entry.
     * @param formatter Function to create a string message of the state and error.
     */
    debug(requestId, state, error, formatter) {
        this.log(logLevel_1.LogLevel.Debug, requestId, state, error, formatter);
    }
    /**
     * Writes an information log entry.
     * @param requestId Guid of the request.
     * @param state The entry to be written. Can be also an object.
     * @param error The error related to this entry.
     * @param formatter Function to create a string message of the state and error.
     */
    information(requestId, state, error, formatter) {
        this.log(logLevel_1.LogLevel.Information, requestId, state, error, formatter);
    }
    /**
     * Writes a warning log entry.
     * @param requestId Guid of the request.
     * @param state The entry to be written. Can be also an object.
     * @param error The error related to this entry.
     * @param formatter Function to create a string message of the state and error.
     */
    warning(requestId, state, error, formatter) {
        this.log(logLevel_1.LogLevel.Warning, requestId, state, error, formatter);
    }
    /**
     * Writes an error log entry.
     * @param requestId Guid of the request.
     * @param state The entry to be written. Can be also an object.
     * @param error The error related to this entry.
     * @param formatter Function to create a string message of the state and error.
     */
    error(requestId, state, error, formatter) {
        this.log(logLevel_1.LogLevel.Error, requestId, state, error, formatter);
    }
    /**
     * Writes a critical log entry.
     * @param requestId Guid of the request.
     * @param state The entry to be written. Can be also an object.
     * @param error The error related to this entry.
     * @param formatter Function to create a string message of the state and error.
     */
    critical(requestId, state, error, formatter) {
        this.log(logLevel_1.LogLevel.Critical, requestId, state, error, formatter);
    }
    /**
     * Writes a none log entry.
     * @param requestId Guid of the request.
     * @param state The entry to be written. Can be also an object.
     * @param error The error related to this entry.
     * @param formatter Function to create a string message of the state and error.
     */
    none(requestId, state, error, formatter) {
        this.log(logLevel_1.LogLevel.None, requestId, state, error, formatter);
    }
    /**
     * Gets a value indicating whether a provided log level is above the current minimum level.
     * @param logLevel Log level to check if is above the current minimum level.
     * @returns True if provided log level is above the current minimum level, else false.
     */
    isInLogLevel(logLevel) {
        switch (this.minimumLevel) {
            case logLevel_1.LogLevel.None:
                if (logLevel === logLevel_1.LogLevel.None) {
                    return true;
                }
                else {
                    return false;
                }
            case logLevel_1.LogLevel.Critical:
                if (logLevel === logLevel_1.LogLevel.None || logLevel === logLevel_1.LogLevel.Critical) {
                    return true;
                }
                else {
                    return false;
                }
            case logLevel_1.LogLevel.Error:
                if (logLevel === logLevel_1.LogLevel.None ||
                    logLevel === logLevel_1.LogLevel.Critical ||
                    logLevel === logLevel_1.LogLevel.Error) {
                    return true;
                }
                else {
                    return false;
                }
            case logLevel_1.LogLevel.Warning:
                if (logLevel === logLevel_1.LogLevel.None ||
                    logLevel === logLevel_1.LogLevel.Critical ||
                    logLevel === logLevel_1.LogLevel.Error ||
                    logLevel === logLevel_1.LogLevel.Warning) {
                    return true;
                }
                else {
                    return false;
                }
            case logLevel_1.LogLevel.Information:
                if (logLevel === logLevel_1.LogLevel.None ||
                    logLevel === logLevel_1.LogLevel.Critical ||
                    logLevel === logLevel_1.LogLevel.Error ||
                    logLevel === logLevel_1.LogLevel.Warning ||
                    logLevel === logLevel_1.LogLevel.Information) {
                    return true;
                }
                else {
                    return false;
                }
            case logLevel_1.LogLevel.Debug:
                if (logLevel === logLevel_1.LogLevel.None ||
                    logLevel === logLevel_1.LogLevel.Critical ||
                    logLevel === logLevel_1.LogLevel.Error ||
                    logLevel === logLevel_1.LogLevel.Warning ||
                    logLevel === logLevel_1.LogLevel.Information ||
                    logLevel === logLevel_1.LogLevel.Debug) {
                    return true;
                }
                else {
                    return false;
                }
            case logLevel_1.LogLevel.Trace:
                if (logLevel === logLevel_1.LogLevel.None ||
                    logLevel === logLevel_1.LogLevel.Critical ||
                    logLevel === logLevel_1.LogLevel.Error ||
                    logLevel === logLevel_1.LogLevel.Warning ||
                    logLevel === logLevel_1.LogLevel.Information ||
                    logLevel === logLevel_1.LogLevel.Debug ||
                    logLevel === logLevel_1.LogLevel.Trace) {
                    return true;
                }
                else {
                    return false;
                }
            default:
                throw new Error(`LogLevel "${logLevel}" not found`);
        }
    }
}
exports.AbstractStringLogger = AbstractStringLogger;
//# sourceMappingURL=abstractStringLogger.js.map